import { PaginatedResponse } from '@synergy/api';
import { createReducer } from '@reduxjs/toolkit';

import { CustomerBonusSettlementDetails } from '../../models/customer-bonus-settlement-details';
import { CustomerBonusSettlementSupplier } from '../../models/customer-bonus-settlement-supplier';
import { PoolCustomerBonusSettlementSupplier } from '../../models/pool-customer-bonus-settlement-supplier';
import {
    customerBonusSettlementDetailsReset,
    customerBonusSettlementSuppliersReset,
    getCustomerBonusSettlementDetail,
    getCustomerBonusSettlementSuppliers,
    getPoolCustomerBonusSettlementCustomers,
    getPoolCustomerBonusSettlementDetail,
} from './bonus-settlements-detail-actions';

export interface BonusSettlementsState {
    bonusSettlementDetails?: CustomerBonusSettlementDetails;
    poolBonusSettlementDetails?: CustomerBonusSettlementDetails;
    bonusSettlementSuppliers: PaginatedResponse<CustomerBonusSettlementSupplier>;
    poolBonusSettlementSuppliers: PaginatedResponse<PoolCustomerBonusSettlementSupplier>;
    requestingBonusSettlementSuppliers: boolean;
    requestingBonusSettlementDetails: boolean;
}

const initialState: BonusSettlementsState = {
    requestingBonusSettlementSuppliers: false,
    requestingBonusSettlementDetails: false,
    bonusSettlementSuppliers: {
        page: 0,
        limit: 0,
        total: 0,
        items: [],
    },
    poolBonusSettlementSuppliers: {
        page: 0,
        limit: 0,
        total: 0,
        items: [],
    },
};

export const bonusSettlementsDetailReducer = createReducer(initialState, builder => {
    builder.addCase(customerBonusSettlementDetailsReset, state => ({
        ...state,
        bonusSettlementDetails: undefined,
        poolBonusSettlementDetails: undefined,
    }));

    builder.addCase(customerBonusSettlementSuppliersReset, state => ({
        ...state,
        bonusSettlementSuppliers: initialState.bonusSettlementSuppliers,
        poolBonusSettlementSuppliers: initialState.poolBonusSettlementSuppliers,
    }));

    builder.addCase(getCustomerBonusSettlementSuppliers.pending, state => {
        state.requestingBonusSettlementSuppliers = true;
    });

    builder.addCase(getCustomerBonusSettlementSuppliers.fulfilled, (state, action) => {
        if (action.payload) {
            state.bonusSettlementSuppliers = action.payload;
        }

        state.requestingBonusSettlementSuppliers = false;
    });

    builder.addCase(getPoolCustomerBonusSettlementCustomers.pending, state => {
        state.requestingBonusSettlementSuppliers = true;
    });

    builder.addCase(getPoolCustomerBonusSettlementCustomers.fulfilled, (state, action) => {
        if (action.payload) {
            state.poolBonusSettlementSuppliers = action.payload;
        }

        state.requestingBonusSettlementSuppliers = false;
    });

    builder.addCase(getCustomerBonusSettlementDetail.pending, state => {
        state.requestingBonusSettlementSuppliers = true;
    });

    builder.addCase(getCustomerBonusSettlementDetail.fulfilled, (state, action) => {
        if (action.payload) {
            state.bonusSettlementDetails = action.payload;
        }

        state.requestingBonusSettlementSuppliers = false;
    });

    builder.addCase(getPoolCustomerBonusSettlementDetail.pending, state => {
        state.requestingBonusSettlementSuppliers = true;
    });

    builder.addCase(getPoolCustomerBonusSettlementDetail.fulfilled, (state, action) => {
        if (action.payload) {
            state.poolBonusSettlementDetails = action.payload;
        }

        state.requestingBonusSettlementSuppliers = false;
    });
});
